import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { lastValueFrom, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/services/authentication/authentication.service';
import { TokenVerification } from '@app/core/services/authentication/models/authentication.models';
import { DmsService } from '@app/core/services/dms/dms.service';
import { LocalStorageItems } from '@app/core/services/localstorage/localstorage.enum';
import { User } from '@app/core/services/user/user.model';
import { UserService } from '@app/core/services/user/user.service';

export function msalInitializer(): Promise<void> {
	const msalService: MsalService = inject(MsalService);
	if (window.opener) return Promise.resolve();
	return lastValueFrom(msalService.handleRedirectObservable(), { defaultValue: undefined })
		.then(() => undefined)
		.catch(() => undefined);
}

export function appInitializer(): Promise<any> {
	const authenticationService: AuthenticationService = inject(AuthenticationService);
	const userService: UserService = inject(UserService);
	inject(DmsService); //TODO: Remove DmsService After dms uses their own login
	// TODO: use a brand new user service.
	const user: User = JSON.parse(localStorage.getItem(LocalStorageItems.UserData));
	return new Promise(resolve => {
		const isOpenRoute: boolean = window.location.host.includes('open'); //TODO: Check if this the correct way to check if the route is open.

		if (isOpenRoute) {
			return of(null)
				.subscribe()
				.add(resolve as any); //TODO: Check if this is the correct way to resolve the promise.
		} else {
			authenticationService
				.verifyToken()
				.pipe(
					switchMap((res: TokenVerification) => {
						if (res) {
							if (user) {
								userService.updateActiveUser(user);
							}
							return userService.get();
						} else {
							return of(null);
						}
					})
				)
				.subscribe()
				.add(resolve as any); //TODO: Check if this is the correct way to resolve the promise.
		}
	});
}
